/* eslint-disable no-magic-numbers */
import {
	MATTRESS_TOPPERS_PATH,
	MATTRESSES_PATH,
	SOLAR_PATH,
} from "@/config/site/favy";
import {
	getHeaderParts,
	getPreventRenderingCompanyListHeader,
	getVertical,
} from "@/selectors";
import { useSelector } from "react-redux";

export const CompanyListHeader = () => {
	const vertical = useSelector(getVertical);
	const headerParts = useSelector(getHeaderParts);
	const preventRenderingCompanyListHeader = useSelector(
		getPreventRenderingCompanyListHeader,
	);

	if (preventRenderingCompanyListHeader || !headerParts) {
		return null;
	}

	const usesTwoColumnLayout = [
		MATTRESSES_PATH,
		MATTRESS_TOPPERS_PATH,
		SOLAR_PATH,
	].includes(vertical);

	const getGridColsClass = () => {
		if (usesTwoColumnLayout) {
			// 4 column layout
			return "tw:grid-cols-[240px_325px_130px_110px] tw:lg:grid-cols-[255px_350px_90px_150px] tw:lg2:grid-cols-[280px_340px_150px_135px]";
		}

		// 5-column layout
		return "tw:grid-cols-[240px_320px_90px_80px_90px] tw:lg:grid-cols-[260px_320px_90px_80px_90px] tw:lg2:grid-cols-[280px_335px_100px_100px_100px]";
	};

	return (
		<div className="tw:mt-0 tw:hidden tw:bg-white tw:lg:block">
			<ul
				className={`company-list-header tw:m-0 tw:grid tw:list-none tw:items-center tw:p-[11px_0] tw:lg2:p-[16px_0_12px_0] ${getGridColsClass()}`}
			>
				{headerParts.map((part, idx) => (
					<li
						key={idx}
						className="tw:m-0 tw:w-full tw:bg-none tw:p-0 tw:font-montserrat tw:text-sm tw:leading-4 tw:font-semibold tw:tracking-[0.03em] tw:text-[rgb(75,85,99)]"
					>
						{part}
					</li>
				))}
			</ul>
		</div>
	);
};
